<div class="grid grid-cols-12 gap-4 px-4 pb-4 h-full">
  <div class="col-span-12 min-[1400px]:col-span-3 bg-white rounded-lg flex flex-col h-full overflow-hidden">
    <div class="flex flex-col">
      <app-review-selected-challanges [diagnosisSessionId]="sessionId"></app-review-selected-challanges>
    </div>
    <div class="flex flex-col">
      <app-review-input-informations [diagnosisSessionId]="sessionId"></app-review-input-informations>
    </div>
  </div>
  <div class="col-span-12 min-[1400px]:col-span-3 bg-white rounded-lg h-full overflow-hidden">
    <div class="flex flex-col h-full overflow-auto">
      <app-review-selected-solutions [diagnosisSessionId]="sessionId" />
    </div>
  </div>

  <div class="col-span-12 min-[1400px]:col-span-6 bg-white rounded-lg h-full overflow-hidden">
    <div class="flex flex-col h-full overflow-auto">
      <app-diagnosis-summary-view [diagnosisSessionId]="sessionId" />
    </div>
  </div>
</div>
